import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_button = _resolveComponent("vxe-button");
  return $props.visible ? (_openBlock(), _createBlock(_component_vxe_button, {
    key: 0,
    mode: $props.mode,
    status: $props.type,
    icon: $props.icon,
    size: $props.size,
    name: $props.name,
    round: $props.round,
    circle: $props.circle,
    disabled: $props.disabled,
    loading: $props.loading,
    "permission-code": $props.permission,
    "router-link": $setup.routerLink,
    "class-name": $props.className,
    "popup-class-name": $props.dropdownClassName,
    placement: $props.placement,
    "destroy-on-close": $props.destroyOnClose,
    trigger: $props.trigger,
    transfer: $props.transfer,
    onClick: $setup.handleClick,
    onDropdownClick: $setup.handleDropdownClick
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString($props.title), 1)]), _renderSlot(_ctx.$slots, "icon"), $setup.dropdownMenus.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 0
    }, _renderList($setup.dropdownMenus, (item, idx) => {
      return _openBlock(), _createBlock(_component_vxe_button, {
        key: idx,
        loading: item.loading,
        disabled: item.disabled,
        icon: typeof item.icon === 'string' ? item.icon : '',
        name: item.name,
        title: item.title
      }, null, 8, ["loading", "disabled", "icon", "name", "title"]);
    }), 128)) : _createCommentVNode("", true)]),
    _: 3
  }, 8, ["mode", "status", "icon", "size", "name", "round", "circle", "disabled", "loading", "permission-code", "router-link", "class-name", "popup-class-name", "placement", "destroy-on-close", "trigger", "transfer", "onClick", "onDropdownClick"])) : _createCommentVNode("", true);
}